(function() {
    'use strict';

    angular.module('app').directive('clipart', clipartDirective);

    function clipartDirective() {
        return {restrict: 'A', link: link}

        function link($scope, $element) {
            $element.ready(apply);

            function apply() {
                var self = $($element);

                // Clipart Preview
                // - - - - - - - - - - - - - - - - - - - - - - - - - - - - -
                self.find('.js-clipart').on('click', 'li', function() {

                    var clipartPosition = $(this).closest('.reveal').attr('id');
                    var clipartId = $(this).find('img').attr('data-id');
                    var $clipartIdInput = $("#"+clipartPosition+"-clipart-id");

                    // Set Clipart ID for Angular
                    $clipartIdInput.val(clipartId);
                    $clipartIdInput.trigger('change');
                });

                var identifier = {
                    searchInput: '.clipart__input',
                    searchClear: '.clipart__clear',
                    searchHeading: '.clipart__heading',
                    searchCount: '.clipart__count',
                    searchResults: '.clipart__results',
                    searchLoading: '<li class="js-clipart-loading"><div class="clipart__box">'
                            + '<i class="[ fa fa-spin fa-refresh ] clipart__loading"></i></div></li>',
                    searchWord: '.clipart__word',
                    loadingArea: '.js-clipart-loading'
                };

                // Pseudo class for clipArt
                function clipArt() {
                    $scope.searchIcons = searchIcons;

                    var self = {},
                    // The following will be for the current page amount
                        options = {
                            resultsCleared: false,
                            pageQuantity: 50,
                            page: 1,
                            totalIcons: 0,
                            searchString: 55,
                            searchType: "collectionName",
                            modal: "",
                            form: "",
                            requestLink: '/clipArt/infinite',
                            randomize: false,
                            randomPageLimit: 100, // this will be the total amount of pages to randomize
                            randomPageArray: [],
                            iconsArray: []
                        };

                    // This is the function that will be called to retrieve the initial collection
                    self.initialCollection = function (form) {
                        options.modal = $('#' + form).parent();
                        options.form = form;
                        options.requestLink = '/clipArt/infinite';
                        options.iconsArray = [];
                        var modal = options.modal;

                        // Clear search text input
                        $(modal.find(identifier.searchInput)).val('');
                        // loading bar will be added in results area
                        modal.find(identifier.searchResults).html(identifier.searchLoading);
                        options.page = 1;

                        options.randomize = true;
                        options.randomPageArray = randomizePageOrder(options.randomPageLimit);

                        $.ajax(
                            {
                                'method': 'GET',
                                'url': '/clipArt/initial',
                                'dataType': 'json',
                            }
                        ).done(function (response) {
                                options.totalIcons = response.totalSearchIcons;
                                var html = convertResponse(response);

                                if (html != '') {
                                    modal.find(identifier.loadingArea).remove();
                                    modal.find(identifier.searchResults).append(html);

                                    modal.find(identifier.searchResults).parent().on("scroll", function () {
                                        scrolledDown(modal);
                                    });
                                    options.page = 2;
                                } else {
                                    modal.find(identifier.loadingArea).remove();
                                }

                            });

                    };

                    // This function will be the call back for the onclick event
                    self.clear = function () {

                        var modal = options.modal;

                        //go ahead and clear areas with text
                        $(modal.find(identifier.searchInput)).val('');
                        $(modal.find(identifier.searchHeading)).empty();
                        //$(modal.find(identifier.searchCount)).empty();
                        $(modal.find(identifier.searchResults)).empty();

                        //options.resultsCleared = true;

                        modal.find(identifier.searchResults).parent().off("scroll");
                        //go ahead and load initial icons
                        self.initialCollection(options.form);

                        return false;
                    };

                    //this will be the call to the function that inserts the search
                    //response clip art items and will perform ajax call
                    function searchIcons() {
                        var modal = options.modal;
                        self.restart();

                        modal.find(identifier.searchResults).html(identifier.searchLoading);

                        options.searchString = modal.find(identifier.searchInput).val();
                        options.searchType = 'iconName';
                        options.randomize = false;
                        options.requestLink = '/clipArt/search' + '/' +  options.searchString;

                        // will check to see if the input is empty and if so it will return false
                        if (options.searchString === "") {
                            modal.find(identifier.searchResults).html("Please enter a search String");
                            return false;
                        }

                        $(modal.find(identifier.searchResults)).parent().scrollTop(0); // will scroll to top

                        requestAndInsert(options.requestLink + '/' + options.page);

                        return false;
                    };

                    //this will be the call back function for the scroll event
                    function scrolledDown(modal) {

                        var content = modal.find(identifier.searchResults);


                        // this will be a boolean variable that will tell if user has scrolled
                        // down to a little before the bottom

                        var scrolledPast = (content.parent().scrollTop() + content.parent().innerHeight() >= content.parent()[0].scrollHeight - 20);

                        //var hasMoreIcons = (options.page - 1) * options.pageQuantity < options.totalIcons;
                        var hasMoreIcons = (status.theEnd == true) ? false : true;

                        if (hasMoreIcons && scrolledPast && !options.resultsCleared) {
                            retrieveNext();
                        }

                    };

                    function retrieveNext () {
                        var modal = options.modal;
                        modal.find(identifier.searchResults).parent().off("scroll");

                        modal.find(identifier.searchResults).append(identifier.searchLoading);

                        requestAndInsert(
                            options.requestLink + '/'
                                + (options.randomize ? options.randomPageArray[options.page] : options.page)
                        );

                    }

                    // this function will empty out areas and set page to 1
                    // also reset totalIcons to 0
                    self.restart = function () {
                        var modal = options.modal;

                        options.iconsArray = [];
                        options.page = 1;
                        options.totalIcons = 0;
                        options.resultsCleared = false;

                        modal.find(identifier.searchResults).html('');
                        //modal.find(identifier.searchCount).empty();
                        modal.find(identifier.searchHeading).empty();

                        modal.find(identifier.searchResults).parent().off("scroll");
                    };

                    // this function will request clipart information and insert into html
                    function requestAndInsert ( url) {
                        var modal = options.modal;
                        $.ajax(
                            {
                                'method': 'GET',
                                'url': url,
                                'dataType': 'json',
                            }
                        ).done(function (response) {

                                if (options.page == 1) {
                                    options.totalIcons = parseInt(response.totalSearchCount);
                                }

                                if (options.totalIcons > 0 || (options.page != 1)) {
                                    var html = convertResponse(response);

                                    if (html != '') {
                                        //modal.find(identifier.searchCount).html("Total number of icons: " + options.totalIcons);

                                        modal.find(identifier.loadingArea).remove();
                                        modal.find(identifier.searchResults).append(html);

                                        modal.find(identifier.searchResults).parent().on("scroll", function () {
                                            scrolledDown(modal);
                                        });
                                        options.page++;
                                    } else {
                                        modal.find(identifier.loadingArea).remove();
                                    }

                                } else {
                                    modal.find(identifier.searchResults).html('<div>There are no search results to display.</div>');
                                }

                            });
                    }

                    // this function will convert the response from the request made in requestAndInsert
                    function convertResponse(response) {
                        var icon;
                        var count = response.icons.length;
                        var html = '';
                        for (var i = 0; i < count; ++i) {
                            icon = response.icons[i];

                            if (options.iconsArray.indexOf(icon.id) == -1) {

                                html += '<li data-close><div class="clipart__box"><img src="' + icon.preview_url
                                        + '" data-name="' + icon.term + '" title="' + icon.term
                                        + '" class="clipartimg" data-id="' + icon.id + '">' + '</div>' + '</li>';

                                options.iconsArray.push(icon.id);
                            }

                        }
                        return html;
                    }
                    function randomizePageOrder(totalPages) {
                        var pages = [];
                        for (var i = 1; i <= totalPages; i++) {
                            pages.push(i);
                        }
                        return pages.sort(randomSort);

                    }

                    function randomSort(a,b) {
                        return( parseInt( Math.random()*10 ) %2 );
                    }

                    return self;
                };

                var clipart = new clipArt();

                self.find('.chooseClipart').click(function () {
                    var initiator = $(this).data('toggle');

                    clipart.initialCollection(initiator + '-form');

                    //when the clear item is clicked clipArt.initialCollection will run
                    self.find(initiator).find(identifier.searchClear).click(function () {
                        return clipart.clear();
                    });
                });
            }
        }
    }
})();
